import { getRoomLinkUrl } from '../helpers';

type BuildInvitationFooterTextProps = {
  dateTimePart: string;
  roomUrlLink: string;
  passcodeText?: string;
  helpText?: string;
  locale: string;
};

export const newLine = '\r\n';

export const buildInvitationFooterText = ({
  dateTimePart,
  roomUrlLink,
  passcodeText,
  helpText,
  locale,
}: BuildInvitationFooterTextProps): string => {
  let text = '';

  if (dateTimePart !== '') {
    text += `${dateTimePart}${newLine}${newLine}`;
  }

  text += getRoomLinkUrl(roomUrlLink, locale);

  if (passcodeText !== undefined) {
    text += `${newLine}${newLine}${passcodeText}`;
  }

  if (helpText !== undefined) {
    text += `${newLine}${newLine}${helpText}`;
  }
  return text;
};
